export default __webpack_public_path__ + "static/media/money-check-alt.7b92b3cc.svg";